import React, { useCallback, useEffect, useState } from 'react';
import { adminApi } from '../services/api';

const StoreStatusPage: React.FC = () => {
  const [isOpen, setIsOpen] = useState(true);
  const [updatedAt, setUpdatedAt] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const load = useCallback(async () => {
    setError('');
    setLoading(true);
    try {
      const s = await adminApi.getPublicStoreStatus();
      setIsOpen(Boolean(s.is_open));
      setUpdatedAt(s.updated_at ?? '');
    } catch (e: unknown) {
      setError(e instanceof Error ? e.message : String(e));
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void load();
  }, [load]);

  const persist = async (next: boolean) => {
    setSaving(true);
    setError('');
    try {
      const s = await adminApi.patchStoreStatus(next);
      setIsOpen(Boolean(s.is_open));
      setUpdatedAt(s.updated_at ?? '');
    } catch (e: unknown) {
      setError(e instanceof Error ? e.message : String(e));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={{ maxWidth: 560 }}>
      <p style={{ fontSize: 11, fontWeight: 600, letterSpacing: '0.15em', color: '#888', textTransform: 'uppercase', marginBottom: 4 }}>
        ระบบร้าน
      </p>
      <h2 style={{ fontSize: 22, fontWeight: 700, marginBottom: 8 }}>สถานะรับคำสั่งซื้อ</h2>
      <p style={{ fontSize: 14, color: '#78716c', lineHeight: 1.55, marginBottom: 24 }}>
        ปิดเมื่อพักร้านหรือไม่พร้อมรับโอนสลิป — Mini App จะซิงก์จากเซิร์ฟเวอร์ (โพลประมาณ 45 วินาที) และ API หยุดรับการสร้างออเดอร์ทันที
      </p>

      {error ? (
        <div style={{ padding: 14, borderRadius: 12, background: '#fff1f2', color: '#b91c1c', marginBottom: 18 }}>{error}</div>
      ) : null}

      <div
        style={{
          padding: '24px 22px',
          borderRadius: 16,
          background: '#fff',
          border: '1.5px solid #e8e6e3',
          marginBottom: 20,
        }}
      >
        {loading ? (
          <p style={{ color: '#a8a29e' }}>กำลังโหลด...</p>
        ) : (
          <>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 12 }}>
              <span style={{ fontSize: 42, lineHeight: 1 }}>{isOpen ? '🟢' : '🔴'}</span>
              <div>
                <p style={{ fontSize: 18, fontWeight: 700, color: isOpen ? '#15803d' : '#991b1b' }}>
                  {isOpen ? 'เปิดรับสั่ง' : 'ปิดรับสั่ง'}
                </p>
                {updatedAt ? (
                  <p style={{ fontSize: 12, color: '#78716c', marginTop: 4 }}>
                    อัปเดตจากระบบ: {new Date(updatedAt).toLocaleString('th-TH')}
                  </p>
                ) : null}
              </div>
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10, marginTop: 20 }}>
              <button
                type="button"
                disabled={saving || isOpen}
                onClick={() => persist(true)}
                style={{
                  padding: '14px 20px',
                  minHeight: 48,
                  borderRadius: 12,
                  border: '1px solid #bbf7d0',
                  background: '#f0fdf4',
                  color: '#15803d',
                  fontWeight: 700,
                  fontSize: 15,
                  cursor: saving ? 'wait' : 'pointer',
                  opacity: isOpen ? 0.55 : 1,
                  WebkitTapHighlightColor: 'transparent',
                  touchAction: 'manipulation',
                }}
              >
                {saving ? 'กำลังบันทึก…' : 'เปิดร้าน'}
              </button>
              <button
                type="button"
                disabled={saving || !isOpen}
                onClick={() => persist(false)}
                style={{
                  padding: '14px 20px',
                  minHeight: 48,
                  borderRadius: 12,
                  border: '1px solid #fecaca',
                  background: '#fef2f2',
                  color: '#991b1b',
                  fontWeight: 700,
                  fontSize: 15,
                  cursor: saving ? 'wait' : 'pointer',
                  opacity: !isOpen ? 0.55 : 1,
                  WebkitTapHighlightColor: 'transparent',
                  touchAction: 'manipulation',
                }}
              >
                {saving ? 'กำลังบันทึก…' : 'ปิดร้าน'}
              </button>
            </div>
          </>
        )}
      </div>

      <button
        type="button"
        onClick={() => void load()}
        disabled={loading}
        style={{
          padding: '10px 16px',
          borderRadius: 10,
          border: '1px solid #d6d3d1',
          background: '#fff',
          fontSize: 13,
          fontWeight: 600,
          cursor: loading ? 'not-allowed' : 'pointer',
        }}
      >
        โหลดสถานะใหม่
      </button>
    </div>
  );
};

export default StoreStatusPage;
